import React from "react";
import { DownloadReportButton } from "@components/common/download-report-button";
/**
 * The header's download control. It stays a thin pass-through rather than a reimplementation:
 * DownloadReportButton owns the export dialog and the in-progress state, and already renders
 * the filled square this header wants.
 */
export const HeaderDownloadButton = (props) => React.createElement(DownloadReportButton, Object.assign({}, props));
export default HeaderDownloadButton;
